import cns from 'classnames';
import {
  isCommercialCarsFilterFeature,
  isEmissionStickerFeature,
} from 'modules/features';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Row from 'react-bootstrap/lib/Row';
import { connect } from 'react-redux';

import {
  InputBoxesField,
  InputBoxesGroupField,
} from 'components/forms/InputBoxes';
import { PriceInputRangeControl } from 'components/forms/filters/Price';
import ExteriorColorIcon from 'components/icons/ExteriorColor';
import { MONTHLY_PRICE } from 'helpers/fieldOptions/ad/priceType';
import { hitTypes, withTracker } from 'helpers/tracking';

import { MAX, MIN } from 'helpers/fieldOptions';

import { InputBoxField } from 'components/forms/InputBox';
import { RangeSliderField } from 'components/forms/RangeSlider';
import { SelectGroupField } from 'components/forms/Select';
import { DistanceGroupField } from 'components/forms/filters/Location/Distance';
import { GeoLocationGroupField } from 'components/forms/filters/Location/GeoLocation';
import { MileageGroupField } from 'components/forms/filters/Mileage';
import { YearGroupField } from 'components/forms/filters/Year';
import { MakeGroupField } from 'components/forms/filters/vehicle/Make';
import { ModelGroupField } from 'components/forms/filters/vehicle/Model';
import { SubTypeGroupField } from 'components/forms/filters/vehicle/SubType';
import {
  AIRBAG_NAME,
  BODY_TYPE_NAME,
  COLOR_NAME,
  COMFORT_NAME,
  CONSUMPTION_RANGE_NAME,
  DOOR_RANGE_NAME,
  EMISSION_STICKER_NAME,
  ENV_STANDARD_NAME,
  EXTRAS_NAME,
  FUEL_TYPE_NAME,
  INTERIOR_NAME,
  LIGHT_NAME,
  MAX_MONTHLY_PRICE,
  MAX_PRICE_VALUE,
  METALLIC_NAME,
  MILEAGE_RANGE_NAME,
  MIN_MONTHLY_PRICE,
  MIN_PRICE_VALUE,
  MONTHLY_PRICE_RANGE_NAME,
  MULTIMEDIA_NAME,
  NOT_DAMAGED_NAME,
  PARKING_SENSORS_NAME,
  POWER_RANGE_NAME,
  POWER_TYPE_NAME,
  PREV_OWNER_NAME,
  PRICE_RANGE_NAME,
  PRICE_TYPE_NAME,
  SEAT_COMFORT_NAME,
  SEAT_RANGE_NAME,
  SECURITY_NAME,
  SERVICE_HISTORY_NAME,
  SMOKER_NAME,
  TRANSMISSION_NAME,
  UPHOLSTERY_NAME,
  YEAR_RANGE_NAME,
} from '../../constants';
import BlockWrapper from './BlockWrapper';
import FiltersTitle from './FiltersTitle';

import bodyTypeIcons from './bodyTypeIcons';

import { changePrice } from './actions';
import mapStateToProps from './mapStateToProps';

import cn from './styles.local.less';

class FilterBlocks extends Component {
  static propTypes = {
    formName: PropTypes.string.isRequired,
    options: PropTypes.shape({
      airbag: PropTypes.array.isRequired,
      bodyType: PropTypes.array.isRequired,
      commercialBodyType: PropTypes.array.isRequired,
      color: PropTypes.array.isRequired,
      comfort: PropTypes.array.isRequired,
      consumptionRange: PropTypes.array.isRequired,
      doorRange: PropTypes.array.isRequired,
      envStandard: PropTypes.array.isRequired,
      emissionSticker: PropTypes.array.isRequired,
      fuelType: PropTypes.array.isRequired,
      interior: PropTypes.array.isRequired,
      light: PropTypes.array.isRequired,
      make: PropTypes.array.isRequired,
      metallic: PropTypes.array.isRequired,
      multimedia: PropTypes.array.isRequired,
      parkingSensor: PropTypes.array.isRequired,
      powerMax: PropTypes.array.isRequired,
      powerMin: PropTypes.array.isRequired,
      powerType: PropTypes.array.isRequired,
      prevOwner: PropTypes.array.isRequired,
      seatComfort: PropTypes.array.isRequired,
      seatRange: PropTypes.array.isRequired,
      security: PropTypes.array.isRequired,
      serviceHistory: PropTypes.array.isRequired,
      transmission: PropTypes.array.isRequired,
      upholstery: PropTypes.array.isRequired,
    }),
    showMonthlyPrice: PropTypes.bool.isRequired,
    showPriceOption: PropTypes.bool.isRequired,
    changePrice: PropTypes.func.isRequired,
    tracker: PropTypes.object.isRequired,
  };

  getPriceOptions = (priceTypeOptions) =>
    this.props.showMonthlyPrice
      ? priceTypeOptions
      : priceTypeOptions.filter(
          (priceType) => priceType.value !== MONTHLY_PRICE,
        );

  handlePriceChange = () => {
    const { formName, changePrice } = this.props;

    changePrice({ formName });
  };

  handlePriceOptionSliderChange = (name, value) => {
    const { tracker } = this.props;

    tracker.track(hitTypes.PRICE_RANGE_SLIDER_CHANGE, {
      label:
        name === PRICE_RANGE_NAME ? 'PriceRangeSlider' : 'MonthlyRangeSlider',
      value,
    });
  };

  handlePriceOptionInputControlChange = (name, value) => {
    const { tracker } = this.props;

    tracker.track(hitTypes.PRICE_INPUT_RANGE_CHANGE, {
      label:
        name === PRICE_RANGE_NAME
          ? 'PriceRangeInputBox'
          : 'MonthlyRangeInputBox',
      value,
    });
  };

  renderBodyTypeIcon({ input, boxElement, value }) {
    const Icon = bodyTypeIcons[value];

    return (
      <span className={cns({ [cn.isActiveParent]: input.checked })}>
        {boxElement}
        {Icon ? (
          <Icon className={cns(cn.icon, { [cn.isActive]: input.checked })} />
        ) : null}
      </span>
    );
  }

  renderExteriorColorIcon({ input, outerColor, boxElement }) {
    return (
      <span className={cns({ [cn.isActiveParent]: input.checked })}>
        {boxElement}
        <ExteriorColorIcon name={outerColor} />
      </span>
    );
  }

  renderBox({ className, inputNode, iconNode, labelNode, value }) {
    return (
      <label className={cns(className, cn.box)} data-qa-value={value}>
        {inputNode}
        {iconNode}
        {labelNode}
      </label>
    );
  }

  renderRowBox({
    inputNode,
    isPlaceholder,
    labelNode,
    value,
    input: { checked },
  }) {
    return (
      <label className={cns(cn.rowLabel, { [cn.activeRowLabel]: checked })}>
        {inputNode}
        {isPlaceholder ? (
          labelNode
        ) : (
          <div className={cns(cn.label, `label_${value}`)}>{labelNode}</div>
        )}
      </label>
    );
  }

  renderControlLabel({ className, ...rest }) {
    return <ControlLabel {...rest} className={cns(className, cn.bold)} />;
  }

  renderRowContainer(props) {
    return (
      <div>
        <div className={cns('form-control', cn.rowContainer)} {...props} />
      </div>
    );
  }

  render() {
    const { formName, options, showPriceOption } = this.props;
    const colProps = {
      md: 3,
      sm: 4,
    };
    const boxProps = {
      ...colProps,
      type: 'checkbox',
      Box: this.renderBox,
      boxClassName: cn.checkIcon,
    };

    return (
      <div className={cn.root}>
        <BlockWrapper title={__('filterBlocks.titles.vehicle')}>
          <Row data-qa-selector="make-model-subtype-section">
            <Col {...colProps}>
              <MakeGroupField
                formName={formName}
                ControlLabel={this.renderControlLabel}
              />
            </Col>
            <Col {...colProps}>
              <ModelGroupField
                formName={formName}
                ControlLabel={this.renderControlLabel}
              />
            </Col>
            <Col {...colProps}>
              <SubTypeGroupField
                formName={formName}
                ControlLabel={this.renderControlLabel}
              />
            </Col>
          </Row>
          <Row data-qa-selector="mileage-section" className={cn.rangeBlock}>
            <Col xs={6} {...colProps}>
              <MileageGroupField
                label={__('filterBlocks.titles.km.from')}
                ControlLabel={this.renderControlLabel}
                name={`${MILEAGE_RANGE_NAME}.${MIN}`}
                formName={formName}
                rangeType={MIN}
                placeholder={__('search.filters.any')}
              />
              <div className={cn.dash} />
            </Col>
            <Col xs={6} {...colProps}>
              <MileageGroupField
                label={__('filterBlocks.titles.km.to')}
                ControlLabel={this.renderControlLabel}
                name={`${MILEAGE_RANGE_NAME}.${MAX}`}
                formName={formName}
                rangeType={MAX}
                placeholder={__('search.filters.any')}
              />
            </Col>
          </Row>
          <Row data-qa-selector="year-section" className={cn.rangeBlock}>
            <Col xs={6} {...colProps}>
              <YearGroupField
                label={__('filterBlocks.titles.year.from')}
                ControlLabel={this.renderControlLabel}
                name={`${YEAR_RANGE_NAME}.${MIN}`}
                formName={formName}
                rangeType={MIN}
                placeholder={__('search.filters.any')}
              />
              <div className={cn.dash} />
            </Col>
            <Col xs={6} {...colProps}>
              <YearGroupField
                label={__('filterBlocks.titles.year.to')}
                ControlLabel={this.renderControlLabel}
                name={`${YEAR_RANGE_NAME}.${MAX}`}
                formName={formName}
                rangeType={MAX}
                placeholder={__('search.filters.any')}
              />
            </Col>
          </Row>
        </BlockWrapper>
        <BlockWrapper title={__('filterBlocks.titles.priceOptions')}>
          <div data-qa-selector="price-section">
            <Row>
              <Col xs={12} sm={6} md={4}>
                <InputBoxesField
                  name={PRICE_TYPE_NAME}
                  options={this.getPriceOptions(options.priceType)}
                  type="radio"
                  xs={6}
                  sm={6}
                  md={6}
                />
              </Col>
            </Row>

            <Row className={cn.priceOptionsRow}>
              <Col xs={12} sm={6}>
                {showPriceOption ? (
                  <Fragment>
                    <RangeSliderField
                      name={PRICE_RANGE_NAME}
                      formName={formName}
                      InputControl={PriceInputRangeControl}
                      onInputControlChange={(value) =>
                        this.handlePriceOptionInputControlChange(
                          PRICE_RANGE_NAME,
                          value,
                        )
                      }
                      onSliderChange={(value) =>
                        this.handlePriceOptionSliderChange(
                          PRICE_RANGE_NAME,
                          value,
                        )
                      }
                      RangeLabel={() => null}
                      minValue={MIN_PRICE_VALUE}
                      maxValue={MAX_PRICE_VALUE}
                      emptyValue={{
                        min: MIN_PRICE_VALUE,
                        max: MAX_PRICE_VALUE,
                      }}
                      className={cn.rangeSliderControl}
                      step={500}
                      isRangeMode
                      showLabelBefore
                      onChanged={this.handlePriceChange}
                    />
                  </Fragment>
                ) : (
                  <Fragment>
                    <RangeSliderField
                      name={MONTHLY_PRICE_RANGE_NAME}
                      formName={formName}
                      RangeLabel={() => null}
                      InputControl={PriceInputRangeControl}
                      onInputControlChange={(value) =>
                        this.handlePriceOptionInputControlChange(
                          MONTHLY_PRICE_RANGE_NAME,
                          value,
                        )
                      }
                      onSliderChange={(value) =>
                        this.handlePriceOptionSliderChange(
                          MONTHLY_PRICE_RANGE_NAME,
                          value,
                        )
                      }
                      minValue={MIN_MONTHLY_PRICE}
                      maxValue={MAX_MONTHLY_PRICE}
                      emptyValue={{
                        min: MIN_MONTHLY_PRICE,
                        max: MAX_MONTHLY_PRICE,
                      }}
                      className={cn.rangeSliderControl}
                      step={10}
                      isRangeMode
                      showLabelBefore
                      onChanged={this.handlePriceChange}
                    />
                  </Fragment>
                )}
              </Col>
            </Row>
          </div>
        </BlockWrapper>

        <BlockWrapper title={__('filterBlocks.titles.location')}>
          <Row data-qa-selector="location-section">
            <Col {...colProps}>
              <FiltersTitle>
                {__('filterBlocks.titles.locationSearch')}
              </FiltersTitle>
              <GeoLocationGroupField formName={formName} />
            </Col>
            <Col {...colProps}>
              <FiltersTitle>{__('filterBlocks.titles.distance')}</FiltersTitle>
              <DistanceGroupField
                formName={formName}
                modalTitle={__('filterBlocks.titles.distance')}
              />
            </Col>
          </Row>
        </BlockWrapper>

        <BlockWrapper title={__('filterBlocks.titles.engine')}>
          <FiltersTitle>{__('filterBlocks.titles.power')}</FiltersTitle>
          <Row data-qa-selector="power-section">
            <Col xs={6} {...colProps}>
              <SelectGroupField
                clearable
                name={`${POWER_RANGE_NAME}.min`}
                options={options.powerMin}
                placeholder={__('search.filters.any')}
                modalTitle={__('filterBlocks.titles.power')}
              />
              <div className={cn.dashWithTitle} />
            </Col>
            <Col xs={6} {...colProps}>
              <SelectGroupField
                clearable
                name={`${POWER_RANGE_NAME}.max`}
                options={options.powerMax}
                placeholder={__('search.filters.any')}
                modalTitle={__('filterBlocks.titles.power')}
              />
            </Col>
            <Col xs={10} {...colProps}>
              <InputBoxesField
                name={POWER_TYPE_NAME}
                type="radio"
                options={options.powerType}
                sm={4}
                xs={3}
              />
            </Col>
          </Row>
          <div data-qa-selector="fuelType-section">
            <FiltersTitle>{__('filterBlocks.titles.fuelType')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={FUEL_TYPE_NAME}
              options={options.fuelType}
              xs={6}
            />
          </div>

          <div data-qa-selector="transmission-section">
            <FiltersTitle>{__('filterBlocks.titles.gearType')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={TRANSMISSION_NAME}
              options={options.transmission}
              xs={6}
            />
          </div>
        </BlockWrapper>

        <BlockWrapper title={__('filterBlocks.titles.environment')}>
          <Row data-qa-selector="owners-section">
            <Col {...colProps}>
              <SelectGroupField
                clearable
                label={__('filterBlocks.titles.consumption')}
                name={CONSUMPTION_RANGE_NAME}
                options={options.consumptionRange}
                placeholder={__('search.filters.any')}
              />
            </Col>

            <Col {...colProps}>
              <SelectGroupField
                clearable
                label={__('filterBlocks.titles.envStandard')}
                name={ENV_STANDARD_NAME}
                options={options.envStandard}
                placeholder={__('search.filters.any')}
              />
            </Col>

            {isEmissionStickerFeature && (
              <Col {...colProps} sm={6}>
                <InputBoxesGroupField
                  name={EMISSION_STICKER_NAME}
                  Container={this.renderRowContainer}
                  Box={this.renderRowBox}
                  type="radio"
                  label={__('filterBlocks.titles.emissionSticker')}
                  options={options.emissionSticker}
                  placeholder={__('search.filters.any')}
                />
              </Col>
            )}
          </Row>
        </BlockWrapper>

        <BlockWrapper title={__('filterBlocks.titles.vehicleHistory')}>
          <div data-qa-selector="service-history-section">
            <Row data-qa-selector="owners-section">
              <Col {...colProps}>
                <InputBoxesField
                  {...boxProps}
                  sm={12}
                  md={12}
                  name={SERVICE_HISTORY_NAME}
                  options={options.serviceHistory}
                />
              </Col>
              <Col {...colProps}>
                <InputBoxField
                  className={cn.box}
                  label={__('filterBlocks.checkboxes.smoker')}
                  name={SMOKER_NAME}
                  type="checkbox"
                />
              </Col>
              <Col {...colProps}>
                <InputBoxField
                  className={cn.box}
                  label={__('filterBlocks.checkboxes.notDamaged')}
                  name={NOT_DAMAGED_NAME}
                  type="checkbox"
                />
              </Col>
            </Row>
          </div>

          <Row data-qa-selector="owners-section">
            <Col {...colProps}>
              <SelectGroupField
                clearable
                label={__('filterBlocks.titles.numberOfVehicleOwners')}
                name={PREV_OWNER_NAME}
                options={options.prevOwner}
                placeholder={__('search.filters.any')}
              />
            </Col>
          </Row>
        </BlockWrapper>

        <BlockWrapper title={__('filterBlocks.titles.bodyType')}>
          <div data-qa-selector="bodyType-section">
            {isCommercialCarsFilterFeature && (
              <FiltersTitle>
                {__('filterBlocks.titles.newUsedCars')}
              </FiltersTitle>
            )}
            <InputBoxesField
              {...boxProps}
              name={BODY_TYPE_NAME}
              options={options.bodyType}
              Icon={this.renderBodyTypeIcon}
              sm={6}
            />

            {isCommercialCarsFilterFeature && (
              <Fragment>
                <FiltersTitle>
                  {__('filterBlocks.titles.commercialVehicles')}
                </FiltersTitle>
                <InputBoxesField
                  {...boxProps}
                  name={BODY_TYPE_NAME}
                  options={options.commercialBodyType}
                  Icon={this.renderBodyTypeIcon}
                />
              </Fragment>
            )}
          </div>
          <Row>
            <Col {...colProps} data-qa-selector="seats-section">
              <FiltersTitle>
                {__('filterBlocks.titles.numberOfSeats')}
              </FiltersTitle>
              <SelectGroupField
                clearable
                name={`${SEAT_RANGE_NAME}`}
                options={options.seatRange}
                placeholder={__('search.filters.any')}
                modalTitle={__('filterBlocks.titles.numberOfSeats')}
              />
            </Col>
            <Col {...colProps} data-qa-selector="doors-section">
              <FiltersTitle>
                {__('filterBlocks.titles.numberOfDoors')}
              </FiltersTitle>
              <SelectGroupField
                clearable
                name={`${DOOR_RANGE_NAME}`}
                options={options.doorRange}
                placeholder={__('search.filters.any')}
                modalTitle={__('filterBlocks.titles.numberOfDoors')}
              />
            </Col>
          </Row>
        </BlockWrapper>

        <BlockWrapper title={__('filterBlocks.titles.features')}>
          <FiltersTitle>{__('filterBlocks.titles.airbags')}</FiltersTitle>
          <Row data-qa-selector="airbag-section">
            <Col {...colProps}>
              <SelectGroupField
                clearable
                name={AIRBAG_NAME}
                options={options.airbag}
                placeholder={__('search.filters.any')}
                modalTitle={__('filterBlocks.titles.airbags')}
              />
            </Col>
          </Row>

          <div data-qa-selector="security-section">
            <FiltersTitle>{__('filterBlocks.titles.security')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={SECURITY_NAME}
              options={options.security}
            />
          </div>

          <div data-qa-selector="interior-section">
            <FiltersTitle>{__('filterBlocks.titles.interior')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={INTERIOR_NAME}
              options={options.interior}
            />
          </div>

          <div data-qa-selector="multimedia-section">
            <FiltersTitle>{__('filterBlocks.titles.multimedia')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={MULTIMEDIA_NAME}
              options={options.multimedia}
            />
          </div>

          <div data-qa-selector="comfort-section">
            <FiltersTitle>{__('filterBlocks.titles.comfort')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={COMFORT_NAME}
              options={options.comfort}
            />
          </div>

          <div data-qa-selector="seatComfort-section">
            <FiltersTitle>{__('filterBlocks.titles.seatComfort')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={SEAT_COMFORT_NAME}
              options={options.seatComfort}
            />
          </div>

          <div data-qa-selector="light-section">
            <FiltersTitle>{__('filterBlocks.titles.light')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={LIGHT_NAME}
              options={options.light}
            />
          </div>

          <div data-qa-selector="parking-sensors-section">
            <FiltersTitle>
              {__('filterBlocks.titles.parkingSensors')}
            </FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={PARKING_SENSORS_NAME}
              options={options.parkingSensor}
            />
          </div>

          <div data-qa-selector="exterior-section">
            <FiltersTitle>{__('filterBlocks.titles.exterior')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={EXTRAS_NAME}
              options={options.extra}
            />
          </div>

          <div data-qa-selector="upholstery-section">
            <FiltersTitle>{__('filterBlocks.titles.upholstery')}</FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={UPHOLSTERY_NAME}
              options={options.upholstery}
            />
          </div>
        </BlockWrapper>

        <BlockWrapper title={__('filterBlocks.titles.color')}>
          <Row data-qa-selector="color-exterior-section">
            <FiltersTitle>
              {__('filterBlocks.titles.exteriorColor')}
            </FiltersTitle>
            <InputBoxesField
              {...boxProps}
              name={COLOR_NAME}
              options={options.color}
              Icon={this.renderExteriorColorIcon}
              withRow={false}
              xs={6}
            />
            <span data-qa-selector="color-metallic-section">
              <InputBoxesField
                {...boxProps}
                name={METALLIC_NAME}
                options={options.metallic}
                Icon={this.renderExteriorColorIcon}
                withRow={false}
                xs={6}
                sm={6}
              />
            </span>
          </Row>
        </BlockWrapper>
      </div>
    );
  }
}

export default withTracker(
  connect(mapStateToProps, { changePrice })(FilterBlocks),
);
